// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1lJkK","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__jBMl6"};